import { combineReducers } from 'redux';
import content from './contentReducer';
import user from './userReducer';
import popup from './popupReducer';

export default combineReducers({
    content,
    user,
    popup
});